import SelectPeriodStart from './select-period-start'
import SelectPeriodEnd from './select-period-end'
import {useInitPeriod} from './select-period-shared'

const SelectPeriod = (props) => {
    const mode = props.mode

    // Инициализация периода здесь, чтобы Start/End не дублировали запрос
    useInitPeriod(mode === 'multiple' || mode === 'single')

    return (
        <>
            {
                mode === 'multiple-toolbar1' ?
                         <SelectPeriodStart initPeriod={true} />
                :
                    mode === 'multiple-toolbar2' ?
                        <SelectPeriodEnd initPeriod={true} />
                        :
                    mode === 'multiple' ?
                        <>
                            <div className={'col-xl-2 col-lg-2 col-md-3 col-sm-6 col-xs-12'}>
                                <SelectPeriodStart initPeriod={true} />
                            </div>
                            <div className={'col-xl-2 col-lg-2 col-md-3 col-sm-6 col-xs-12 mt20xs'}>
                                <SelectPeriodEnd initPeriod={true} />
                            </div>
                        </>
                        :
                mode === 'single' ?
                    <div className="row">
                        <div className={'col-sm-4 col-md-3 col-lg-2'} style={{minWidth: '130px'}}>
                            <SelectPeriodEnd
                                initPeriod={true}
                                label={'Период:'}
                                displayFormat='monthAndYear'
                            />
                        </div>
                    </div>
                    : <div className="row">
                        <div className={'col-sm-4 col-md-3 col-lg-2'}>Period mode not selected!</div>
                    </div>
            }
        </>
    )
}

export default SelectPeriod
